import React, {Component} from 'react';
import {Modal, Button, Checkbox} from 'semantic-ui-react';

const formTypeMetaTag = '[FORM_TYPE]';

const generalQuestionsBaseTemplate = [
  'Los datos del vehículo están ingresados correctamente?',
  'Se consulto previamente Manuales de Reparación, Boletines, etc?',
  'Se adjunto fotos, videos o audios en donde se verifique a plenitud el síntoma?',
];

const otherQuestionsBaseTemplate = [
  'Los datos del vehículo están ingresados correctamente?',
  'Se consultó, analizó e investigó previamente instrucciones o procesos de Diagnóstico de Manuales ' +
  'de Reparación, Boletines, etc?',
  'Se adjunta los resultados de cada medición realizada en el vehículo de las inspecciones mencionadas ' +
  'en el Manual de Reparación? (Estos resultados pueden estar escritos a mano junto a las indicaciones ' +
  `del Manual de Reparación y escaneados para adjuntarlos al ${formTypeMetaTag}.`,
  'Se adjunto el Historial del vehículo?',
  'Se adjunto fotos, videos o audios en donde se verifique a plenitud el síntoma?',
];

class ConfirmBeforePublishModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'answer1': false,
      'answer2': false,
      'answer3': false,
      'answer4': false,
      'answer5': false,
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onPublishClick = this.onPublishClick.bind(this);
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  onPublishClick() {
    this.props.confirmClick();
    this.onCloseModalClick();
  }

  onAnswerCheckboxChange(numberQuestion, event, checked) {
    const newState = {};
    newState[`answer${numberQuestion}`] = checked;
    this.setState(newState);
  }

  fetchData() {
    this.setState({'modalWasOpen': true});
  }

  formatQuestions(questionsBaseTemplate) {
    const {formType} = this.props;
    return questionsBaseTemplate.map((question) => {
      return question.replace(formTypeMetaTag, formType);
    });
  }

  getConfirmationQuestions() {
    const {section} = this.props;
    const generalQuestions = this.formatQuestions(generalQuestionsBaseTemplate);
    const otherQuestions = this.formatQuestions(otherQuestionsBaseTemplate);
    const listQuestions =
      section === 'general' ? generalQuestions : otherQuestions;
    return listQuestions;
  }

  checkingAnswers() {
    const {answer1, answer2, answer3, answer4, answer5} = this.state;
    const {section} = this.props;
    if (section === 'general' && answer1 && answer2 && answer3) {
      return false;
    }
    if (answer1 && answer2 && answer3 && answer4 && answer5) {
      return false;
    }
    return true;
  }

  renderQuestions() {
    const listQuestions = this.getConfirmationQuestions();
    return listQuestions.map((item, index) => {
      const numberQuestion = index + 1;
      return (
        <Checkbox
          key={index}
          label={item}
          defaultChecked={this.state[`answer${numberQuestion}`]}
          onChange={(event, {checked}) => this.onAnswerCheckboxChange(numberQuestion, event, checked)}
        />
      );
    });
  }

  render() {
    const {modalWasOpen} = this.state;
    const {loading, saving} = this.props;

    return (
      <Modal
        size='tiny'
        onOpen={() => this.fetchData()}
        className='binning-search-boxes'
        open={modalWasOpen}
        trigger={
          <Button
            primary
            type='submit'
            className='toyota-primary'
            disabled={loading || saving}
          >
            Publicar
          </Button>
        }
      >
        <Modal.Header>Preguntas de confirmación</Modal.Header>

        <Modal.Content>
          <Modal.Description>{this.renderQuestions()}</Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>Cancelar</Button>
          <Button
            positive
            disabled={this.checkingAnswers()}
            onClick={this.onPublishClick}
          >
            Aceptar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ConfirmBeforePublishModal;
